// Vocabulario del EXPEDIENTE del aparato (`GET /sales/{saleId}/device`), no de la plantilla del
// producto: proveedor y modo quedaron congelados al enrolar, y el estado es del teléfono de hoy.
import { LoanDeviceMdmStatusEnum } from '@fiado/type-kit/bin/loanCredit/enums/LoanDeviceMdmStatusEnum';
import { MdmProviderEnum } from '@fiado/type-kit/bin/retailCatalog/enums/MdmProviderEnum';
import { PENDING_CELL } from '../../customers/lib/customersFormat';

/** La venta de contado o derivada nunca enroló equipo: no hay expediente que leer, y está bien. */
export const DEVICE_NOT_APPLICABLE_NOTE =
    'Esta venta no llevó crédito SureKeep, así que el equipo nunca se enroló en el candado remoto.';

/** Hay crédito y todavía no hay expediente: el enrolamiento es un paso posterior al cierre. */
export const DEVICE_PENDING_ENROLLMENT_NOTE =
    'El equipo de esta venta todavía no se enrola en el candado remoto.';

/** La lectura falló: es un «no sé», jamás un «no tiene candado». */
export const DEVICE_UNREADABLE_NOTE =
    'No se pudo leer el expediente del candado de este equipo, así que su estado no se puede mostrar.';

/** Estado del candado en el expediente (`LoanDeviceMdmStatusEnum` del type-kit). */
const LOCK_STATUS_LABEL: Record<LoanDeviceMdmStatusEnum, string> = {
    [LoanDeviceMdmStatusEnum.NOT_ENROLLED]: 'Sin enrolar',
    [LoanDeviceMdmStatusEnum.ENROLLING]: 'Enrolando',
    [LoanDeviceMdmStatusEnum.ACTIVE]: 'Activo',
    [LoanDeviceMdmStatusEnum.LOCKED]: 'Bloqueado',
    [LoanDeviceMdmStatusEnum.RELEASED]: 'Liberado',
    [LoanDeviceMdmStatusEnum.ARCHIVED]: 'Archivado sin enrolar',
    [LoanDeviceMdmStatusEnum.FAILED]: 'Enrolamiento rechazado',
    [LoanDeviceMdmStatusEnum.FAILED_NOT_FOUND]: 'IMEI desconocido para el proveedor',
    [LoanDeviceMdmStatusEnum.MANUAL_REVIEW]: 'En revisión manual',
};

/** La grafía del proveedor con el que se enroló (`MdmProviderEnum` del type-kit). */
const PROVIDER_LABEL: Record<MdmProviderEnum, string> = {
    [MdmProviderEnum.TRUSTONIC]: 'Trustonic',
    [MdmProviderEnum.DATACULTR]: 'Datacultr',
    [MdmProviderEnum.MOTOSAFE]: 'Motosafe',
};

/** Traduce un código del expediente. El que todavía no tiene nombre se muestra crudo. */
function expedientCodeLabel(
    code: string | undefined,
    labels: Record<string, string | undefined>,
): string {
    const trimmed = code?.trim() ?? '';
    if (!trimmed) return PENDING_CELL;
    return labels[trimmed] ?? trimmed;
}

/** El estado del candado en el aparato. Es el autoritativo: el del proveedor solo lo comenta. */
export function deviceLockStatusLabel(status: string | undefined): string {
    return expedientCodeLabel(status, LOCK_STATUS_LABEL);
}

/** El proveedor con el que se enroló este teléfono, no el que el catálogo pactó para el modelo. */
export function deviceProviderLabel(provider: string | undefined): string {
    return expedientCodeLabel(provider, PROVIDER_LABEL);
}
